function NRMisconfigurationIcon({ height = '24', width = '24', color = 'currentColor' }) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18 8H17V6C17 3.24 14.76 1 12 1C9.24 1 7 3.24 7 6H9C9 4.34 10.34 3 12 3C13.66 3 15 4.34 15 6V8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H12V20H6V10H18L20 11V10C20 8.9 19.1 8 18 8Z"
        fill={color}
      />
      <path
        d="M21.52 16.37L22.66 15.37L21.66 13.64L20.21 14.13C19.89 13.86 19.53 13.65 19.13 13.5L18.83 12H16.83L16.53 13.49C16.13 13.64 15.77 13.85 15.45 14.12L14 13.63L13 15.36L14.14 16.36C14.06 16.86 14.06 17.12 14.14 17.62L13 18.62L14 20.35L15.45 19.86C15.77 20.13 16.13 20.34 16.53 20.49L16.83 22H18.83L19.13 20.51C19.53 20.36 19.89 20.15 20.21 19.88L21.66 20.37L22.66 18.64L21.52 17.64C21.6 17.13 21.6 16.87 21.52 16.37ZM17.83 19C16.73 19 15.83 18.1 15.83 17C15.83 15.9 16.73 15 17.83 15C18.93 15 19.83 15.9 19.83 17C19.83 18.1 18.93 19 17.83 19Z"
        fill={color}
      />
    </svg>
  );
}
export default NRMisconfigurationIcon;
